module.exports = {
    RapidNeighborJoining: require('./dist/neighbor-joining.js').RapidNeighborJoining,
    allocateSquareMatrix: require('./dist/utils.js').allocateSquareMatrix
};